import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

import store from "../vuex/store_friendList.js";
import http from '../http.js';
import qs from "qs";

export const FriendListHandler = {
  Hello: function () {
    alert("FriendListHandler.js");
  },
  AddFavorite: function (socialleadId, staffId) {
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/AddFavorite",
      type: "post",
      cache: false,
      async: true,
      data: {
        socialleadId: socialleadId,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {},
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  },
  GetFriendList: function (token) {
    http
      .post(
        "/Friend/FriendList",
        qs.stringify({
          token: token
        })
      )
      .then(function (response) {
        if (response.data) {
          store.dispatch("GetFriendList", response.data.list);
        } else {
          alert(response.data.ErrorMessage);
        }
      })
      .catch(function (error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  },

  //連動畫面資料
  GetGroupFriendList: function (groupId, staffId) {
    http
      .post(
        "/Friend/GetGroupFriendList",
        qs.stringify({
          groupId: groupId,
          staffId: staffId
        })
      )
      .then(function (response) {
        store.dispatch("GetFriendList", response.data.list);
      })
      .catch(function (error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  },
  GetGroupFriendItem: function (groupId, staffId) {
    var friend = null;
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/GetGroupFriendList",
      type: "post",
      cache: false,
      async: false,
      timeout: 60000,
      data: {
        groupId: groupId,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {
        if (data.Success) {
          friend = data.list;
        } else {
          alert(data.ErrorMessage);
        }
      },
      error: function (a, b, c) {
        window.location.href = "/#/Error";
      }
    });
    return friend;
  },
  QueryUnreadList: function (staffId) {
    http
      .post(
        "/Friend/QueryUnreadList",
        qs.stringify({
          staffId: staffId,
        })
      )
      .then(function (response) {
        store.dispatch("GetFriendList", response.data.list);
      })
      .catch(function (error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  },
  //未分類名單
  QueryUnclassifiedList: function (staffId) {
    http
      .post(
        "/Friend/QueryUnclassifiedList",
        qs.stringify({
          staffId: staffId,
        })
      )
      .then(function (response) {
        store.dispatch("GetFriendList", response.data.list);
      })
      .catch(function (error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  },
  //最近聯繫名單
  QueryRecentlyStaffMainContact: function (staffId, sendertype) {
    http
      .post(
        "/Friend/QueryRecentlyStaffMainContact",
        qs.stringify({
          staffId: staffId,
          sendertype: sendertype
        })
      )
      .then(function (response) {
        store.dispatch("GetFriendList", response.data.list);
      })
      .catch(function (error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  },
  //今日應聯名單
  QueryTodayStaffMainContact: function (staffId) {
    http
      .post(
        "/Friend/QueryTodayStaffMainContact",
        qs.stringify({
          staffId: staffId,
        })
      )
      .then(function (response) {
        store.dispatch("GetFriendList", response.data.list);
      })
      .catch(function (error) {
        console.log(error);
        window.location.href = "/#/Error";
      });
  },
  AddFriendGroupItem: function (socialleadId, groupId, staffId) {
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/AddFriendGroupItem",
      type: "post",
      cache: false,
      async: false,
      data: {
        socialleadId: socialleadId,
        groupId: groupId,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {},
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  },
  DeleteFriendGroupItem: function (socialleadId, groupId, staffId) {
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/DeleteFriendGroupItem",
      type: "post",
      cache: false,
      async: false,
      data: {
        socialleadId: socialleadId,
        groupId: groupId,
        staffId: staffId
      },
      dataType: "json",
      success: function (data) {},
      error: function (a, b, c) {
        //window.location.href = "/#/Error";
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/handler/FriendListHandler.js